import {FC, useEffect, useState} from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useAuth } from '../auth'
import axios from 'axios'

const ManageYourSubscription: FC = () => {

  const { currentUser } = useAuth()

  const API_URL = process.env.REACT_APP_API_URL
  const SITE_URL = process.env.REACT_APP_SITE_URL

  const [ stripeSession, setStripeSession ] = useState();

  const myProfileHeader = () => {
    axios
      .get(API_URL + "/app/myProfileHeader/" + currentUser?.id)
      .then((response) => {
        console.log(response.data);

        var session_id = response.data[0].session_id;

        console.log(session_id);

      
        setStripeSession(session_id);
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
      myProfileHeader()
    }, [])

  return (
    <>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
        {/* begin::Body */}
        <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
          {/* begin::Form */}
          <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
            {/* begin::Wrapper */}
            <div className='w-lg-800px p-10'>
              {/* begin::Content */}
              <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
                {/* begin::Logo */}
                <a href='#' className='mb-12'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('media/logos/Logotipo_fullcolor.png')}
                    className='h-125px'
                  />
                </a>
                {/* end::Logo */}
                {/* begin::Wrapper */}
                <div></div>
                {/* end::Wrapper */}
              </div>

              <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
                <div className='w-100'>
                  <div className='row mb-10'>
                    <div className='col-lg-12 '>
                      <div className='pb-5 pb-lg-5'>
                        <h1 className='d-flex align-items-center text-gray-900 select-plan-text'>
                          Maneja tu suscripción:
                        </h1>

                        <div className='text-gray-500 fs-6'>
                          Si necesitas más información, visita la página
                          <a
                            href={SITE_URL}
                            target='_blank'
                            className='link-primary fw-bolder'
                          >
                            {' '}
                            Planes
                          </a>
                          .
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='fv-row'>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <form
                          action={API_URL + '/stripe/createPortalSession'}
                          method='POST'
                          className='text-center'
                        >
                          <input
                            type='hidden'
                            id='session-id'
                            name='session_id'
                            value={stripeSession}
                          />
                          {(() => {
                            if (currentUser) {
                              if (currentUser.plan != 'Admin') {
                                return (
                                  <>
                                    <button
                                      id='checkout-and-portal-button'
                                      type='submit'
                                      className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'
                                    >
                                      Maneja tu suscripción
                                    </button>
                                  </>
                                )
                              }
                            }
                          })()}
                          {/* <button
                          id="checkout-and-portal-button"
                          type="submit"
                          className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3"
                        >
                          Maneja tu suscripción
                        </button> */}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end::Content */}
              {/* begin::Footer */}
              <div className='d-flex flex-center flex-column-auto p-10'>
                <div className='d-flex align-items-center fw-bold fs-6'>
                  <a
                    href={SITE_URL + '/terminos-y-condiciones/'}
                    className='text-muted text-hover-primary px-2'
                    target='_blank'
                  >
                    Términos y condiciones
                  </a>

                  {/* <a
                  href="https://app.buscadorcriteria.com.mx/"
                  className="text-muted text-hover-primary px-2"
                >
                  Contacto
                </a> */}

                  {/* <a href='#' className='text-muted text-hover-primary px-2'>
                  Contact Us
                </a> */}
                </div>
              </div>
              {/* end::Footer */}
            </div>
            {/* end::Wrapper */}
          </div>
          {/* end::Form */}
        </div>
        {/* end::Body */}
      </div>
    </>
  )
}

export { ManageYourSubscription }